import { Box, IconButton, Paper, Stack } from '@mui/material'
import ByzMuiDataGrid from 'src/components/core-components/mui/data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { GridColDef } from '@mui/x-data-grid-premium';
import { useBaseQuery } from 'src/api/core/useBaseQuery';
import { useMutation } from '@tanstack/react-query';
import { baseService } from 'src/api/core/baseService';
import { queryClient } from 'src';
import React, { useState } from 'react';
import ByzDeleteConfirmDialog from 'src/components/core-components/mui/ByzDeleteConfirmDialog';



function LiquidOutTable({ comId }: any) {

    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [deleteTargetId, setDeleteTargetId] = useState<number | null>(null);

    const { data: liquidOutData, isLoading, refetch } = useBaseQuery<any>({
        endpoint: `/reference/api/Card/GetFluidBalanceFluidOutputs?comId=${comId}`,
        queryKey: ['liquidOutData', comId],
        options: {
            enabled: comId > 0,
        }
    });

    const deleteMutation = useMutation({
        mutationFn: (id: number) => baseService.delete(`/reference/api/Card/DeleteFluidBalanceFluidOutput/`, id),
        onSuccess: () => {
            refetch();
            queryClient.invalidateQueries({ queryKey: ['liquidOutData'] });
            queryClient.invalidateQueries({ queryKey: ['fluidTypesBalance'] });
        },
        onError: (error) => {
            console.error('Silme hatası:', error);
            alert('Silme işlemi başarısız oldu.');
        },
    });

    const deleteDetailMutation = useMutation({
        mutationFn: (id: number) => baseService.delete(`/reference/api/Card/DeleteFluidBalanceFluidOutput/`, id),
        onSuccess: () => {
            refetch();
            queryClient.invalidateQueries({ queryKey: ['liquidOutData'] });
            queryClient.invalidateQueries({ queryKey: ['fluidTypesBalance'] });
        },
        onError: (error) => {
            console.error('Detay silme hatası:', error);
            alert('Detay silme işlemi başarısız oldu.');
        },
    });

    const handleDeleteClick = (id: number) => {
        setDeleteTargetId(id);
        setDeleteDialogOpen(true);
    };

    const handleConfirmDelete = async () => {
        if (deleteTargetId) {
            deleteDetailMutation.mutate(deleteTargetId);
        }
    };


    const outputColumns: GridColDef[] = [
        {
            field: 'fbodate',
            headerName: 'İşlem Zamanı',
            width: 150,
            valueFormatter: (params) => {
                if (!params) return '';
                const date = new Date(params);
                return date.toLocaleString('tr-TR');
            },
        },
        {
            field: 'fname',
            headerName: 'Adı',
            width: 200,
        },
        {
            field: 'totalout',
            headerName: 'Toplam Mkt',
            width: 120,
            valueFormatter: (params) => params ? `${params} ml` : '',
        }
    ];

    // Sub row kolonları
    const detailColumns: GridColDef[] = [
        {
            field: 'amount',
            headerName: 'Miktar',
            width: 120,
            valueFormatter: (params) => params ? `${params} ml` : '',
        },
        {
            field: 'ptime',
            headerName: 'İşlem Zamanı',
            width: 150,
            valueFormatter: (params) => {
                if (!params) return '';
                const date = new Date(params);
                return date.toLocaleString('tr-TR');
            },
        },
        {
            field: 'cuser',
            headerName: 'İşlem Yapan',
            width: 120,
        },
        {
            field: 'explanation',
            headerName: 'Açıklama',
            width: 200,
        },
        {
            field: 'actions',
            headerName: '',
            width: 100,
            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <IconButton size="small" onClick={() => handleDeleteClick(params.row.id)}>
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Stack>
            ),
        },
    ];

    const getDetailPanelContent = React.useCallback(
        ({ row }: any) => {
            if (!row.details || row.details.length === 0) return null;

            return (
                <Box sx={{ p: 2, bgcolor: 'grey.50' }}>
                    <ByzMuiDataGrid
                        columns={detailColumns}
                        rows={row.details}
                        whiteGrid={false}
                        hideFooter
                        autoHeight
                        getRowId={(row) => row.id}
                    />
                </Box>
            );
        },
        [detailColumns]
    );

    const getDetailPanelHeight = React.useCallback(
        ({ row }: any) => {
            if (!row.details || row.details.length === 0) return 0;
            return 'auto';
        },
        []
    );



    return <>
        <Paper sx={{ p: 2, borderRadius: '16px' }}>
            <Box sx={{ mb: 2, fontWeight: 600 }}>Çıkan Sıvı</Box>
            {liquidOutData && !isLoading ? (
                <ByzMuiDataGrid
                    columns={outputColumns}
                    rows={liquidOutData.data || []}
                    whiteGrid={true}
                    hideFooter
                    autoHeight
                    getRowId={(row) => row.rid}
                    getDetailPanelContent={getDetailPanelContent}
                    getDetailPanelHeight={getDetailPanelHeight}
                    slots={{
                        detailPanelExpandIcon: KeyboardArrowDownIcon,
                        detailPanelCollapseIcon: KeyboardArrowDownIcon,
                    }}
                />
            ) : (
                <Box>Yükleniyor...</Box>
            )}
        </Paper>

        <ByzDeleteConfirmDialog
            open={deleteDialogOpen}
            onClose={() => {
                setDeleteDialogOpen(false);
                setDeleteTargetId(null);
            }}
            onConfirm={handleConfirmDelete}
            title="Çıkan Sıvı Kaydını Sil"
            content="Bu çıkan sıvı kaydını silmek istediğinizden emin misiniz?"
            hideSnackbar
        />
    </>
}

export default LiquidOutTable